module.exports = __webpack_public_path__ + "media/images/tiedye/turqdream-8171807ab3e77225d1e8e737bfec4b3f.jpg";